import styled from "styled-components";

export const Overlay = styled.div`
    position: fixed;
    top: 0; left: 0;
    width: 100%; height: 100%;
    background: rgba(0,0,0,0.35);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 300;
    animation: fadeIn 0.2s ease;

    @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
    }
`;

export const Modal = styled.div`
    width: 88%;
    max-width: 420px;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 8px 30px rgba(0,0,0,0.18);
    overflow: hidden;
    animation: slideUp 0.25s ease;

    @keyframes slideUp {
        from { opacity: 0; transform: translateY(20px); }
        to { opacity: 1; transform: translateY(0); }
    }

    .modalHeader {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 18px 20px 14px;
        border-bottom: 1px solid #e9ecef;
    }

    .modalTitle {
        font-family: S-Core-Dream;
        font-size: 17px;
        font-weight: 600;
        color: #212529;
    }
`;

export const CloseBtn = styled.button`
    width: 30px;
    height: 30px;
    border: none;
    border-radius: 8px;
    background: #f8f9fa;
    color: #495057;
    font-size: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.15s;
    &:hover { background: #e9ecef; }
`;

export const StepList = styled.div`
    padding: 16px 20px 20px;
`;

export const StepItem = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 10px 0;
    border-bottom: 1px solid #f1f3f5;

    &:last-child { border-bottom: none; }

    .stepIcon {
        font-size: 20px;
        min-width: 28px;
        text-align: center;
    }

    .stepText {
        font-family: S-Core-Dream;
        font-size: 14px;
        color: #495057;
        line-height: 1.6;
    }
`;
